import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { OptionsType, OptionsTypeResponse } from '../types'

export const OptionsService = {
  getOptions: async (
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<OptionsType[]>> => {
    return apiService.get<AxiosResponse<OptionsType[]>>('options', config)
  },

  getOptionById: async (
    id: string,
  ): Promise<AxiosResponse<OptionsTypeResponse>> => {
    return apiService.get<AxiosResponse<OptionsTypeResponse>>(`options/${id}`)
  },

  createOption: async (option: OptionsType) => {
    return apiService.post<AxiosResponse<OptionsType[]>>('options', option)
  },

  updateOption: async (optionId: string, option: OptionsType) => {
    return apiService.put<AxiosResponse<OptionsType[]>>(
      `options/${optionId}`,
      option,
    )
  },
}
